import computed from './computed'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import props from './props'

export default {
  computed,
  data,
  methods,
  mounted,
  props,

  resourcePath: '/v1/professional/schedules/'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/consultations-made/resources/index.js